import styled from '@emotion/styled';
import StepperItem from './StepperItem';

type StepperProps = {
  steps: string[],
  currentStep: number,
  hideStepName?: boolean,
};

const StepperContainer = styled.div`
  display: flex;
`;

const Stepper = ({ steps, currentStep, hideStepName }: StepperProps) => (
  <StepperContainer>
    {steps.map((name, index) => (
      <StepperItem
        key={name}
        currentStep={currentStep}
        displayStepIndex={index + 1}
        stepName={name}
        hideStepName={hideStepName}
      />
    ))}
  </StepperContainer>
);

export default Stepper;
